import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { Handle, Node, Position } from '@xyflow/react';
import { TreeNode } from 'entitree-flex';
import { memo, useContext, useState } from 'react';
import { FamilyTreeInteractionContext } from './NewFamilyTree';
import { TreeNodeId, TreeNodeType } from './types';

type CustomNodeData = Node<TreeNode<TreeNodeType>>['data'] & {
  label: string;
};

export default memo(({ data }: { data: CustomNodeData }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { openAddNodeDialog, openEditLegalClientDialog, removeNode } =
    useContext(FamilyTreeInteractionContext);

  const handleAddRelation = (relationType: 'partner' | 'child') => {
    console.log(`Add ${relationType} relation with ID: ${data.id}`);
    if (relationType === 'child') {
      openAddNodeDialog(
        data.id,
        data.kind === 'person' ? 'childOnPerson' : 'childOnRelationship'
      );
    } else {
      openAddNodeDialog(data.id, 'partnerOnPerson');
    }

    setAnchorEl(null);
  };

  const handleEditLegalClient = (nodeId: TreeNodeId) => {
    console.log(`Edit legal client with ID: ${nodeId}`);
    openEditLegalClientDialog(nodeId);

    setAnchorEl(null);
  };

  const handleRemoveNode = () => {
    // Implement the logic to remove a node
    console.log(`Remove node with ID: ${data.id}`);
    removeNode(data.id);
  };

  const { isRoot, isPrimaryLineage, label, kind } = data;

  const isTopNode = !data?.parents?.length;
  const isBottomNode = !data?.children?.length;
  const hasChildren = !!data?.children?.length;
  const isRelationNode =
    kind === 'marriage' || kind === 'divorce' || kind === 'family';

  return (
    <>
      <div className='nodrag'>
        {hasChildren && (
          <Handle type='source' position={Position.Bottom} id='h-children' />
        )}

        {!isTopNode && (
          <Handle type='target' position={Position.Top} id='h-parents' />
        )}

        <div>{label}</div>
      </div>
      <IconButton
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        size='small'
      >
        <MoreVertIcon fontSize='inherit' style={{ fontSize: '14px' }} />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => handleAddRelation('child')}>
          Kind hinzufügen
        </MenuItem>
        {!isRelationNode && (
          <>
            <MenuItem onClick={() => handleEditLegalClient(data.id)}>
              Bearbeiten
            </MenuItem>
            {isPrimaryLineage && (
              <MenuItem onClick={() => handleAddRelation('partner')}>
                Partner hinzufügen
              </MenuItem>
            )}
          </>
        )}
        {!isRoot && <MenuItem onClick={handleRemoveNode}>Entfernen</MenuItem>}
      </Menu>
    </>
  );
});
